import React, { useRef, useEffect, useState, Fragment } from "react";
import moment from "moment";
import SunEditor from "suneditor-react";
import styled from "styled-components";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { ReactComponent as SponsorBg } from "assets/sponsor-bg.svg";
import { ReactComponent as Users } from "assets/users-grey.svg";
import { ReactComponent as CheckGreen } from "assets/check-green.svg";
import { ReactComponent as CrossRemove } from "assets/red-cross-slim.svg";
import { ReactComponent as PencilEdit } from "assets/pencil-edit.svg";
import { ReactComponent as TooltipIcon } from "assets/info.svg";

import _SelectComponent from "components/admin-layout/forms/SelectComponent";
import _ChipsSelectComponent from "components/admin-layout/forms/ChipsSelectComponent";
import { PhoneInputs } from "components/auht-layout/pages/questionaries/styled";

import { Input } from "components/common/form/index";
import theme from "models/themes";

import {
  ContainerFlex,
  DocInput,
  Cont,
  InfoBlock,
  DocSelect,
  DocOptions,
  DocTextArea,
  DateWrapper,
  ImageWrapper,
  Column,
  Row,
  StatusBlock,
} from "../containers/container";

import {
  NoneInput,
  WrapperEditor,
  Text,
  ContainerDatePicker,
  NoAvatar,
  FileName,
  FileAction,
  Avatar,
  FooterBlock,
  FooterBolockTxt,
  CheckBox,
  Circle,
  EditableField,
  EditBox,
  EditInput,
} from "./styled";
import { Label, InputLabel as DocInputLabel, VarText, SecondLabel, LabelInfo } from "../text";
import { VarButton } from "../buttons";

// import "suneditor/dist/css/suneditor.min.css";
import { fileEncodeToBase64 } from "../../../helpers";
import Api from "helpers/api";
import { ErrorMessagePortal } from "../errorMessage";
import { CircularProgress } from "components/common/circularProgress";

export const SelectComponent = _SelectComponent;
export const ChipsSelectComponent = _ChipsSelectComponent;

export const TextEditor = (props) => {
  return (
    <Fragment>
      <WrapperEditor>
        <Text>
          <Label>{props.label}</Label>
        </Text>
        <SunEditor
          autoFocus={false}
          setContents=""
          onChange={(e) => {
            props.onChange(e);
          }}
          setOptions={{
            fontSize: [8, 10, 14, 18, 24, 36],
          }}
        />
      </WrapperEditor>
      <NoneInput
        data-auto-focus
        onFocus={() => {
          const needFocus = document.querySelector("[data-focus]");
          if (needFocus) needFocus.focus();
        }}
      />
    </Fragment>
  );
};

const options = {
  fontSize: [8, 10, 14, 18, 24, 36],
  formats: ["p", "blockquote", "h1", "h2", "h3"],
  buttonList: [
    [
      "formatBlock",
      "bold",
      "underline",
      "italic",
      "align",
      "list",
      "image",
      "video",
      "fontColor",
      "fontSize",
      "table",
      "fullScreen",
    ],
  ],
};

export const DateComponent = ({
  label = "",
  defaultValue = new Date(),
  onChange,
  width,
  widthPicker,
  padding,
  isInvestor,
  disabled = false,
  noLabel = false,
  error,
}) => {
  const [value, setValue] = useState(defaultValue ? new Date(defaultValue) : new Date());
  const ref = useRef(null);

  const _onChange = () => {
    setValue(moment(ref.current.value));
  };

  useEffect(() => {
    if (ref.current) {
      onChange && onChange(moment(value).utc().format());
    }
  }, [value]);
  return (
    <ContainerDatePicker row w={width || "100%"} justify="space-between" widthPicker={widthPicker}>
      <DateWrapper width="100%">
        {!noLabel ? <DocInputLabel isInvestor={isInvestor}>{label}</DocInputLabel> : null}
        <DocInput
          padding={padding}
          ref={ref}
          onChange={_onChange}
          defaultValue={moment(value).format("YYYY-MM-DD")}
          icon={`/assets/calendar${theme.greyFilter ? "-dark" : ""}.svg`}
          width="100%"
          type="date"
          disabled={disabled}
          error={error}
        />
      </DateWrapper>
    </ContainerDatePicker>
  );
};

export const ChartDateComponent = ({ defaultValue = new Date(), onChange, width, widthPicker }) => {
  const [value, setValue] = useState(defaultValue ? new Date(defaultValue) : new Date());
  const ref = useRef(null);

  const _onChange = () => {
    setValue(moment(ref.current.value));
  };

  useEffect(() => {
    if (ref.current) {
      onChange && onChange(moment(value).utc().format());
    }
  }, [value]);

  return (
    <ContainerDatePicker row w={width || "100%"} justify="space-between" widthPicker={widthPicker}>
      <DateWrapper width="100%">
        <DocInput
          arrowPosition={10}
          height={32}
          ref={ref}
          onChange={_onChange}
          defaultValue={moment(value).format("YYYY-MM-DD")}
          icon={`/assets/calendar${theme.greyFilter ? "-dark" : ""}.svg`}
          width="180px"
          type="date"
        />
      </DateWrapper>
    </ContainerDatePicker>
  );
};

export const DateTimeFieldComponent = ({
  label = "",
  defaultValue = new Date(),
  zIndex = 0,
  onChange,
  padding = false,
  bgPos = false,
  isInvestor,
  error,
}) => {
  const [value, setValue] = useState(new Date(defaultValue));
  const ref1 = useRef(null);

  useEffect(() => {
    onChange && onChange(moment(value).utc().format());
  }, [value]);

  const _onChange = (e) => {
    setValue(`${moment(e.target.value).format("YYYY-MM-DD")} ${ref1.current.value}`);
  };

  const _onChangeTime = (e) => {
    setValue(`${moment(value).format("YYYY-MM-DD")} ${e.target.value}`);
  };

  return (
    <ContainerDatePicker zIndex={zIndex} row w="100%" justify="space-between" align="flex-end" widthPicker="100%">
      <DateWrapper width="calc(60% - 13px)">
        <DocInputLabel isInvestor={isInvestor}>{label}</DocInputLabel>
        <DocInput
          error={error}
          icon={`/assets/calendar${theme.greyFilter ? "-dark" : ""}.svg`}
          width="100%"
          type="date"
          onChange={_onChange}
          defaultValue={moment(value).format("YYYY-MM-DD")}
          padding={padding}
          arrowPosition={bgPos}
        />
      </DateWrapper>
      <DateWrapper width="40%">
        <Input
          error={error}
          ref={ref1}
          type="time"
          width="100%"
          icon={`/assets/clock${theme.greyFilter ? "-dark" : ""}.svg`}
          value={moment(value).format("HH:mm")}
          onChange={_onChangeTime}
          padding={padding}
          arrowPosition={bgPos}
        />
      </DateWrapper>
    </ContainerDatePicker>
  );
};

export const TextFieldComponent = ({
  onChange,
  width = "100%",
  label,
  placeholder,
  defaultValue = "",
  type = "text",
  disabled = false,
  height,
  fontSize,
  labelFontSize,
  error = false,
  errorWithBG,
  pseudo = "",
  isInvestor,
  autoComplite = "new-password",
  value,
  ref,
  noLabel = false,
  children,
  content,
  hiddenLabel,
  margin = 0,
  info = null,
  ...otherProps
}) => {
  return (
    <ContainerFlex marginSize={margin} w={width} content={content} overflow={info ? "visible" : "hidden"}>
      {noLabel ? null : (
        <DocInputLabel hidden={hiddenLabel} labelFsize={labelFontSize} isInvestor={isInvestor}>
          {label}
          {info ? (
            <LabelInfo>
              <TooltipIcon />
              <div className="tooltip-info">{info}</div>
            </LabelInfo>
          ) : null}
        </DocInputLabel>
      )}
      <DocInput
        data-auto-focus
        autoComplete={autoComplite}
        errorWithBG={errorWithBG}
        error={error}
        fontSize={fontSize}
        height={height}
        type={type}
        width="100%"
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        pseudo={pseudo}
        ref={ref}
        {...otherProps}
      />
      {children}
    </ContainerFlex>
  );
};

export const TextFieldComponentPlaceholder = ({
  onChange,
  width = "100%",
  label,
  placeholder,
  defaultValue = "",
  type = "text",
  disabled = false,
  height,
  fontSize,
  labelFontSize,
  error = false,
  errorWithBG = false,
  pseudo = false,
  pseudoText,
  after,
  afterText,
  onKeyDown,
  pseudoSize,
  isInvestor = false,
  padding,
  margin,
  labelExtraStyle,
  ...otherProps
}) => {
  return (
    <Cont
      labelFSize={labelFontSize}
      width={width}
      pseudo={pseudo}
      pseudoText={pseudoText}
      pseudoSize={pseudoSize}
      isInvestor={isInvestor}
      margin={margin}
      after={after}
      afterText={afterText}
    >
      <DocInputLabel isInvestor={isInvestor} labelFsize={labelFontSize} labelExtraStyle={labelExtraStyle}>
        {label}
      </DocInputLabel>
      <DocInput
        errorWithBG={errorWithBG}
        padding={padding}
        error={error}
        fontSize={fontSize}
        height={height}
        type={type}
        width="100%"
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onKeyDown={onKeyDown}
        {...otherProps}
      />
    </Cont>
  );
};

export const InfoBlockComponent = ({ width = "100%", label, children, labelFontSize, isInvestor, margin = 0 }) => {
  return (
    <ContainerFlex w={width} marginSize={margin}>
      <DocInputLabel isInvestor={isInvestor} labelFsize={labelFontSize}>
        {label}
      </DocInputLabel>
      <InfoBlock>{children}</InfoBlock>
    </ContainerFlex>
  );
};

export const StatusComponent = ({ width = "100%", label }) => {
  return (
    <ContainerFlex w={width}>
      <DocInputLabel>{label}</DocInputLabel>
      <StatusBlock bg="#C6C6C6">Pending</StatusBlock>
    </ContainerFlex>
  );
};

export const StatusDinamicComponent = ({ width = "100%", label, movementType }) => {
  const types = {
    INCOME: "#019D52",
    OUTCOME: "#D96666",
    PERSONAL: "#BFDCFC",
    PENDING: "#3F4B78",
    CANCELED: "#D96666",
    OTHER: "#cecece",
    REJECTED: "#FF4343",
  };

  return (
    <ContainerFlex w={width}>
      <DocInputLabel>{label}</DocInputLabel>
      <StatusBlock bg={types[movementType]}>{movementType}</StatusBlock>
    </ContainerFlex>
  );
};

export const ImageUploaderComponent = ({
  width = "100%",
  label,
  sponsorBg,
  onChange,
  file = null,
  token,
  isInvestor = false,
  maxSize,
}) => {
  const [avatar, setAvatar] = useState(null);
  const [fileName, setFileName] = useState(file ? file.fileNameWithExtension : "");
  const [sizeError, setSizeError] = useState(null);

  const inpupRef = useRef(null);

  const onSizeError = (err) => () => setSizeError(err);

  const openFileDialog = () => inpupRef.current.click();

  const onDeleteImage = () => {
    setAvatar(null);
    setFileName("");
    onChange(null);
  };

  const onUploadFile = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > (maxSize || 2097152)) {
        onSizeError({
          error: "Information",
          message: `The size of the image should not exceed ${maxSize ? (maxSize * 0.000001).toFixed(1) : "2"}Mb`,
        })();
        return;
      } else {
        setAvatar(await fileEncodeToBase64(file));
        setFileName(file.name);
        onChange(file);
      }
    }
  };

  useEffect(() => {
    if (file && file.secureHash && file.fileNameWithExtension && token) {
      const { secureHash, fileNameWithExtension } = file;
      Api.getAttachment(token, secureHash, fileNameWithExtension).then((b) => setAvatar(b));
    }
  }, []);

  return (
    <ContainerFlex w={width}>
      <DocInputLabel isInvestor={isInvestor}>{label}</DocInputLabel>
      <ImageWrapper>
        <input ref={inpupRef} type="file" style={{ display: "none" }} accept="image/*" onChange={onUploadFile} />
        <Column>
          {avatar ? (
            <Avatar sponsorBg={sponsorBg} src={avatar} alt="logo" />
          ) : (
            <NoAvatar sponsorBg={sponsorBg} onClick={openFileDialog} />
          )}
        </Column>
        <Column>
          <FileName>{fileName}</FileName>
          {fileName ? (
            <div>
              <FileAction onClick={openFileDialog}>Change Image</FileAction>
              <FileAction del onClick={onDeleteImage}>
                Delete
              </FileAction>
            </div>
          ) : (
            <div>
              <FileName>No {sponsorBg ? "Background" : "Avatar"} Image</FileName>
              <FileAction onClick={openFileDialog}>Upload Image</FileAction>
            </div>
          )}
        </Column>
      </ImageWrapper>
      {sizeError && <ErrorMessagePortal er={sizeError} onClose={onSizeError(null)} />}
    </ContainerFlex>
  );
};

export const GroupsLogoUploader = ({ width = "100%", label, sponsorBg, onChange, defaultAvatar, defaultFileName }) => {
  const [avatar, setAvatar] = useState(null);
  const [fileName, setFileName] = useState("");
  const [sizeError, setSizeError] = useState(null);

  const inpupRef = useRef(null);

  const onSizeError = (err) => () => setSizeError(err);

  useEffect(() => {
    if (!avatar && defaultAvatar) {
      setAvatar(defaultAvatar);
      setFileName(defaultFileName);
      // setFileName(file.name);
    }
  }, [defaultAvatar]);

  const openFileDialog = () => inpupRef.current.click();

  const onUploadFile = async (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 2097152) {
        onSizeError({
          error: "Information",
          message: `The size of the image should not exceed 2Mb`,
        })();
        return;
      } else {
        setAvatar(await fileEncodeToBase64(file));
        setFileName(file.name);
        onChange(file);
      }
    }
  };

  const onDeleteImage = () => {
    setAvatar(null);
    setFileName("");
    onChange(null);
  };

  const rand = Math.round(Math.random() * 1000);

  return (
    <ContainerFlex w={width}>
      <DocInputLabel>{label}</DocInputLabel>
      <ImageWrapper key={`something-${rand}`}>
        <input ref={inpupRef} type="file" style={{ display: "none" }} accept="image/*" onChange={onUploadFile} />
        <Column>
          {sponsorBg ? (
            <SponsorBg />
          ) : avatar ? (
            <Avatar src={avatar} alt="logo" />
          ) : (
            <Users style={{ cursor: "pointer" }} onClick={openFileDialog} />
          )}
        </Column>
        <Column>
          {fileName ? (
            <Fragment>
              <FileName small>{fileName}</FileName>
              <div>
                <FileAction onClick={openFileDialog}>Change image</FileAction>
                <FileAction del onClick={onDeleteImage}>
                  Delete
                </FileAction>
              </div>
            </Fragment>
          ) : (
            <div>
              <Txt>No Image</Txt>
              <UploadImg onClick={openFileDialog}>Upload Image</UploadImg>
            </div>
          )}
        </Column>
      </ImageWrapper>
      {sizeError && <ErrorMessagePortal er={sizeError} onClose={onSizeError(null)} />}
    </ContainerFlex>
  );
};

const Txt = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: -0.02em;
  margin-bottom: 10px;
  color: rgba(24, 24, 24, 0.4);
`;

const UploadImg = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: -0.02em;
  color: ${({ theme: { primary } }) => primary};
  cursor: pointer;
`;

export const SelectFilter = ({
  onChange,
  width,
  placeholder,
  value,
  values = [],
  multiple = false,
  defaultValue,
  margin,
}) => {
  return (
    <ContainerFlex marginSize={margin} w={width}>
      <DocSelect
        height={32}
        arrowPosition={10}
        padding="0 10px"
        multiple={multiple}
        arrow={`/assets/chevron-down${theme.greyFilter ? "-dark" : ""}.svg`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
      >
        {defaultValue ? null : (
          <DocOptions selected disabled>
            none
          </DocOptions>
        )}
        {values.map((e) => (
          <DocOptions key={e} value={e} selected={e === defaultValue}>
            {e}
          </DocOptions>
        ))}
      </DocSelect>
    </ContainerFlex>
  );
};

export const TextAreaComponent = ({
  onChange,
  width = "100%",
  label,
  placeholder,
  defaultValue = "",
  areaHeight,
  labelFsize,
  fSize = 12,
  isInvestor,
  name,
  error = false,
  disabled = false,
  value,
  maxLength,
}) => {
  return (
    <ContainerFlex w={width}>
      <DocInputLabel labelFsize={labelFsize} isInvestor={isInvestor}>
        {label}
      </DocInputLabel>
      <DocTextArea
        fSize={fSize}
        areaHeight={areaHeight}
        type="text"
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        name={name}
        error={error}
        disabled={disabled}
        maxLength={maxLength}
      />
    </ContainerFlex>
  );
};

export const FooterComponent = ({ onChange, width = "100%", label, placeholder, defaultValue = true, name }) => {
  const [checked, setChecked] = useState(defaultValue);

  const onChangeStatus = () => {
    setChecked(!checked);
    onChange(!checked);
  };
  return (
    <ContainerFlex w={width}>
      <DocInputLabel>{label}</DocInputLabel>
      <FooterBlock active={checked}>
        <FooterBolockTxt>{name}</FooterBolockTxt>
        <CheckBox onClick={onChangeStatus} active={checked}>
          <Circle active={checked} />
        </CheckBox>
      </FooterBlock>
    </ContainerFlex>
  );
};

export const SwitcherComponent = ({
  onChange = console.log,
  width = "100%",
  label,
  fSize,
  textMargin,
  defaultValue = true,
  name,
  height,
  labelFsize,
  isInvestor,
  leftText = false,
  secondLabel = "",
  moreLabel = false,
  disabled = false,
  controlledComponent = false,
  value = false,
  wait = false,
  noBorder = false,
  noLabel = false,
}) => {
  const [checked, setChecked] = useState(defaultValue);

  const onChangeStatus = () => {
    !controlledComponent && setChecked(!checked);
    onChange(controlledComponent ? !value : !checked);
  };

  return (
    <ContainerFlex w={width}>
      {noLabel ? null : (
        <DocInputLabel isInvestor={isInvestor} labelFsize={labelFsize}>
          {label}
        </DocInputLabel>
      )}
      {moreLabel && <SecondLabel>{secondLabel}</SecondLabel>}
      <FooterBlock height={height} active={controlledComponent ? value : checked} noBorder={noBorder}>
        {wait ? (
          <CircularProgress size={24} style={{ margin: "auto" }} />
        ) : (
          <Fragment>
            <CheckBox
              leftText={leftText}
              onClick={disabled ? undefined : onChangeStatus}
              active={controlledComponent ? value : checked}
            >
              <Circle active={controlledComponent ? value : checked} />
            </CheckBox>
            <FooterBolockTxt fSize={fSize} margin={textMargin}>
              {name}
            </FooterBolockTxt>
          </Fragment>
        )}
      </FooterBlock>
    </ContainerFlex>
  );
};

export const VariablesComponent = ({ width = "100%", label, variables }) => {
  const renderVariables = () => {
    return Object.keys(variables).map(
      (e) =>
        e !== "messages" && (
          <Row key={e}>
            <VarButton>{e}</VarButton>{" "}
            <VarText>
              <span>-</span> {variables[e]}
            </VarText>
          </Row>
        )
    );
  };
  return (
    <ContainerFlex w={width}>
      <DocInputLabel>{label}</DocInputLabel>
      <ContainerFlex column>{renderVariables()}</ContainerFlex>
    </ContainerFlex>
  );
};

export const TextEditorComponent = ({ label, onChange, defaultValue = "", heightToContent, scrollToTop = false }) => {
  const ref = useRef(null);
  const refId = useRef(Math.random().toString(36).replace("0.", "id-editor"));
  const refWrapper = useRef(null);

  useEffect(() => {
    let item;
    let timerId = setInterval(() => {
      item = document.querySelector(`#${refId.current} .se-dialog.sun-editor-common`);
      if (item) {
        document.querySelector("#sun-editor-portal").appendChild(item);
        clearInterval(timerId);
      }
    }, 100);

    return () => {
      item && item.remove();
      clearInterval(timerId);
    };
  }, []);

  return (
    <Fragment>
      <WrapperEditor
        id={refId.current}
        ref={refWrapper}
        className={heightToContent ? "height-to-content" : ""}
        onFocus={(e) => {}}
      >
        <Text>
          <DocInputLabel>{label}</DocInputLabel>
        </Text>
        <SunEditor
          autoFocus={false}
          onChange={onChange}
          key="isEditor"
          ref={ref}
          placeholder={label}
          setContents={defaultValue}
          setOptions={options}
        />
      </WrapperEditor>
      <NoneInput
        autoFocus={scrollToTop}
        onFocus={() => {
          if (scrollToTop) {
            const needFocus = document.querySelector("[data-focus]");
            if (needFocus) needFocus.focus();
          }
        }}
      />
    </Fragment>
  );
};

export const PhoneComponent = ({
  width = "100%",
  defaultValue,
  fSize,
  placeholder = "Telephone Number",
  label = "Telephone Number",
  dataType = "default",
  onChange = console.log,
  disabled,
  isAdmin = false,
}) => {
  const handleChange = (phone, code) => {
    if (dataType === "default") {
      onChange(phone);
    }
  };
  return (
    <PhoneInputs isAdmin={isAdmin} height="63px" width={width} fSize={fSize}>
      <PhoneInput
        disabled={disabled}
        value={defaultValue}
        placeholder={placeholder}
        inputClass="phone-input"
        buttonClass="phone-flag"
        specialLabel={label}
        onChange={(phone, { dialCode }) => handleChange(phone, dialCode)}
      />
    </PhoneInputs>
  );
};

export const TextFieldEditable = ({
  onChange,
  width = "100%",
  label,
  placeholder,
  defaultValue = "",
  type = "text",
  disabled = false,
  height,
  fontSize,
  labelFontSize,
  error = false,
  errorWithBG,
  pseudo = "",
  isInvestor,
  autoComplite = "new-password",
  value,
  ref,
  noLabel = false,
  children,
  content,
  hiddenLabel,
  fieldId = Math.round(Math.random() * 10000),
  _onChangeName = console.log,
  onRemoveField = console.log,
  ...otherProps
}) => {
  const [editOpen, setEditOpen] = useState(false);

  const onChangeEditOpen = () => setEditOpen(!editOpen);

  const onChangeName = (e) => {
    _onChangeName(e.target.value);
  };

  const onRemove = () => {
    onRemoveField(fieldId);
  };

  return (
    <ContainerFlex w={width} content={content}>
      <EditableField>
        <EditBox w="calc(100% - 40px)">
          {editOpen ? (
            <EditInput isInvestor={isInvestor} autoFocus value={label} onChange={onChangeName} />
          ) : (
            <DocInputLabel hidden={hiddenLabel} labelFsize={labelFontSize} isInvestor={isInvestor}>
              {label}
            </DocInputLabel>
          )}
        </EditBox>
        <EditBox edit={editOpen} w="30px" t="-5px">
          {editOpen ? (
            <CheckGreen onClick={onChangeEditOpen} />
          ) : (
            <PencilEdit className="edit-field-icon" onClick={onChangeEditOpen} />
          )}
          <CrossRemove onClick={onRemove} />
        </EditBox>
      </EditableField>
      <DocInput
        padding="11px 14px 15px"
        data-auto-focus
        autoComplete={autoComplite}
        errorWithBG={errorWithBG}
        error={error}
        fontSize={fontSize}
        height={height}
        type={type}
        width="100%"
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        pseudo={pseudo}
        ref={ref}
        {...otherProps}
      />
      {children}
    </ContainerFlex>
  );
};
